module.exports = __webpack_public_path__ + "img/9788989571155.a5e5d47e.jpg";